module.exports = "*{\n  font-family: helvetica;\n}\n"